
























































import {Component, Vue} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import RegisterDepartment from '@/views/department/RegisterDepartment.vue';
import UpdateDepartment from '@/views/department/UpdateDepartment.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import {progress} from '@/script/progress';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {管理者部署コード, 部署型} from '@/type/department/department';
import {viewEditingStateModule} from '@/store/state/viewEditingState';

@Component({
  components: {
    RegisterForm: RegisterDepartment,
    UpdateForm: UpdateDepartment,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    NormalButton,
    AlertDialog,
  },
})
export default class ListDepartments extends Vue {

  private 部署一覧: 部署型[] = [];
  private 選択部署: 部署型 | null = null;

  private アラートメッセージ: string[] = [];

  private registerModal: boolean = false;
  private updateModal: boolean = false;

  private created(): void {
    this.show();
    viewEditingStateModule.初期化する();
  }

  private async show(): Promise<void> {
    await api.削除を含む部署一覧を取得する()
      .then((response: any) => {
        this.部署一覧 = response;
        if (this.部署一覧.length === 0) {
          this.アラートメッセージ = ['部署は存在しません'];
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
        this.アラートメッセージ = error.data.message;
        this.$modal.show('アラート');
      });
  }

  private select(部署: 部署型): void {
    if (this.isModalOpen) {
      return;
    }
    this.選択部署 = 部署;
  }

  private reload(): void {
    this.show();
    this.選択部署 = null;
  }

  private openRegisterForm(): void {
    this.registerModal = true;
    viewEditingStateModule.画面の編集を開始する();
  }

  private closeRegisterForm(): void {
    this.reload();
    this.registerModal = false;
    viewEditingStateModule.画面の編集を終了する();
  }

  private openUpdateForm(): void {
    this.updateModal = true;
    viewEditingStateModule.画面の編集を開始する();
  }

  private get isModalOpen(): boolean {
    return this.registerModal || this.updateModal;
  }

  private async requestUpdateForm(): Promise<void>  {
    if (this.選択部署 !== null) {
      this.openUpdateForm();
    }
  }

  private closeUpdateForm(): void {
    this.reload();
    this.updateModal = false;
    viewEditingStateModule.画面の編集を終了する();
  }

  private openDeleteDialog(): void {
    this.$modal.show('deleteConfirmDialog');
  }

  private closeDeleteDialog(): void {
    this.$modal.hide('deleteConfirmDialog');
  }

  private deleteHandler(): void {
    progress(this.delete);
  }

  private async delete(): Promise<void> {
    if (this.選択部署 !== null) {
      await api.部署を削除する(this.選択部署)
        .then(
          () => {
            this.closeDeleteDialog();
            this.reload();
          },
          (error: any) => {
            this.closeDeleteDialog();
            if (error.data.errors) {
              this.アラートメッセージ = error.data.errors;
            }
            if (error.data.message && !error.data.errors) {
              this.アラートメッセージ = [error.data.message];
            }
            this.$modal.show('アラート');
          },
        );
    }
  }

  private get isDisabled(): boolean {
    return this.選択部署 === null || this.選択部署.削除フラグ === '削除' || this.選択部署.部署コード === 管理者部署コード;
  }
}
